// UI texts: the Survivors list and the public profile (20. 10. 2026, owner; docs/notes/players.md)
export default {
  title: 'Survivors',
  intro: 'Everyone out there this season. Follow a survivor to keep them on top and see their big moments in the Feed.',
  searchLabel: 'Search by name',
  searchPlaceholder: 'Search by name',
  sortLabel: 'Sort',
  sort: { level: 'Level', score: 'Season Score', activity: 'Activity' },
  total: '{n} survivors',
  totalOne: '1 survivor',
  followingCount: 'Following {n}',
  activity: { today: 'Active today', week: 'This week', earlier: 'Earlier' },
  lv: 'Lv {n}',
  rank: 'Rank {n}',
  points: '{n} pts',
  you: '(you)',
  followingTag: 'Following',
  page: 'Page {page} of {pages}',
  prev: 'Previous',
  next: 'Next',
  empty: { title: 'Nobody by that name', body: 'Names are not unique and searches match any part of a name. Try fewer letters.' },
  emptyAll: { title: 'Nobody out there yet', body: 'Survivors of the season show up here.' },
  rowAria: 'Open {name}’s profile',
  profile: {
    title: 'Survivor',
    lvBg: 'Level {n} · {bg}',
    lvRankBg: 'Level {n} · Rank {rank} · {bg}',
    follow: 'Follow',
    following: 'Following',
    unfollow: 'Unfollow',
    followed: 'You follow {name}. Their big moments come to your Feed.',
    unfollowed: 'You no longer follow {name}',
    followers: '{n} followers',
    followersOne: '1 follower',
    itsYou: 'This is you. Others see this page when they open your name.',
    openSurvivor: 'Open your survivor',
    invite: 'Invite to crew',
    invited: 'Invited',
    season: 'Season Score',
    seasonPlace: 'Place {place} of {n}',
    seasonNoPlace: 'Not ranked yet (300 points)',
    collection: 'Collection book',
    collectionLine: '{found} of {total} fields',
    legendaries: 'Legendaries worn',
    noLegendaries: 'No Legendary worn right now.',
    titles: 'Titles',
    worn: 'worn',
    noTitles: 'No titles yet.',
    crew: 'Crew',
    crewLevel: 'Crew level {n}',
    noCrew: 'Not in a crew.',
    privacy: 'Where a survivor is, what they carry and when they were last on stays private.',
    notFound: 'No survivor here',
    notFoundBody: 'The name may have changed, or the season has moved on.',
    back: 'All survivors',
  },
} as const;
